import {Component, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {LanguageService} from './services/language.service';
import {setCookie} from '../utils/helper';
import {LocalStorageService} from './services/local-storage.service';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {CookieComponent} from './components/cookie/cookie.component';
import {MatDialog} from '@angular/material/dialog';
import {AnalyticsService} from './services/analytics.service';
import {RouterOutlet} from '@angular/router';
import {HeaderComponent} from './components/header/header.component';
import {FooterComponent} from './components/footer/footer.component';

declare const gtag: Function;

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  readonly document = inject(DOCUMENT);
  readonly platformId = inject(PLATFORM_ID);
  title = 'selective-bits';

  constructor(
    private localStorage: LocalStorageService,
    private analyticsService: AnalyticsService,
    public dialog: MatDialog,
    private language: LanguageService) {
    language.init();
  }

  ngOnInit(): void {
        this.initialize();
    }

  private setCookies() {
    setCookie('ad_storage', 'denied', 365)
    setCookie('ad_user_data', 'denied', 365)
    setCookie('ad_personalization', 'denied', 365)
    setCookie('analytics_storage', 'denied', 365)
  }

  private initialize() {
    const hasCookie = this.localStorage.getItem('selective-bits-cookie') === 'true';
    let modalSettings: any = {
      width: '100%',
    }
    if (this.document.defaultView.innerWidth < 768) {
      modalSettings = {
        width: '100%',
        position: {bottom: 0 + 'px', left: 0 + 'px', right: 0 + 'px'}
      }
    } else {
      modalSettings = {
        ...modalSettings,
        position: {bottom: 20 + 'px', left: 20 + 'px'}
      }
    }
    if (isPlatformBrowser(this.platformId)) {
      if (!hasCookie) {
        this.dialog.open(CookieComponent, {
          ...modalSettings,
          panelClass: ['cookie-modal', 'animate-fadeIn'],
          disableClose: true,
          hasBackdrop: false,
          ariaLabel: 'Cookie modal'
        });
        gtag('consent', 'default', {
          'ad_storage': 'denied',
          'ad_personalization': 'denied',
          'analytics_storage': 'denied',
          'ad_user_data':	'denied',
        })
      } else {
        if (isPlatformBrowser(this.platformId)) {
          this.analyticsService.initialize();
        }

        // const script1 = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n' +
        //   '          new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\n' +
        //   '        j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n' +
        //   '        \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n' +
        //   '      })(window,document,\'script\',\'dataLayer\',\'GTM-N9DNXT\');';
        //
        // let node = document.createElement('script');
        // node.innerHTML = script1;
        // node.type = 'text/javascript';
        // node.async = true;
        // document.getElementsByTagName('head')[0].appendChild(node);

        gtag('consent', 'default', {
          'ad_storage': 'granted',
          'ad_personalization': 'granted',
          'analytics_storage': 'granted',
          'ad_user_data': 'granted',
        })
      }
    }
  }
}
